module.exports = __webpack_public_path__ + "static/media/editIcon.e3361fe6.svg";